module.exports = __webpack_public_path__ + "static/media/ipad-table.bab28e74.jpg";